import { createContext, useContext, useEffect, useState } from 'react';

const QueryContext = createContext(null);

const STORAGE_KEYS = {
  platform: 'queryContext.platform',
  country: 'queryContext.country',
  category: 'queryContext.category',
  subCategory: 'queryContext.subCategory',
};

const readStorage = (key, fallback) => {
  try {
    const v = localStorage.getItem(key);
    return v === null ? fallback : v;
  } catch {
    return fallback;
  }
};

const writeStorage = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // localStorage 비활성/할당량 초과는 무시 (다음 세션 복원만 실패)
  }
};

const usePersistedString = (key, defaultValue) => {
  const [value, setValue] = useState(() => readStorage(key, defaultValue));
  useEffect(() => { writeStorage(key, value); }, [key, value]);
  return [value, setValue];
};

export const QueryProvider = ({ children }) => {
  const [selectedPlatform, setSelectedPlatform] = usePersistedString(STORAGE_KEYS.platform, 'tiktok');
  const [selectedCountry, setSelectedCountry] = usePersistedString(STORAGE_KEYS.country, '');
  const [selectedCategory, setSelectedCategory] = usePersistedString(STORAGE_KEYS.category, '');
  const [selectedSubCategory, setSelectedSubCategory] = usePersistedString(STORAGE_KEYS.subCategory, '');
  const [selectedDate, setSelectedDate] = useState(null);

  return (
    <QueryContext.Provider value={{
      selectedPlatform, setSelectedPlatform,
      selectedCountry, setSelectedCountry,
      selectedCategory, setSelectedCategory,
      selectedSubCategory, setSelectedSubCategory,
      selectedDate, setSelectedDate,
    }}>
      {children}
    </QueryContext.Provider>
  );
};

export const useQuery = () => useContext(QueryContext);
